import styled from 'styled-components';

import ShowDisclosureModal from 'components/ShowDisclosureModal';
import StepHeader from 'components/StepHeader';

import {
  Card,
  ChimeLogo,
  DescriptionText,
  PageTitle,
  PageWrapper,
} from 'styles/styleMixins';

const DowntimeCard = styled(Card)`
  padding: 26px 80px 35px;
`;

const DownTimePage = () => {
  return (
    <PageWrapper>
      <DowntimeCard>
        <ChimeLogo />
        <StepHeader>
          <PageTitle>Please try again later</PageTitle>
          <DescriptionText>
            {
              'We’re sorry, new Chime accounts are currently unavailable. Our teams are working to open applications again ASAP. Thank you for your patience.'
            }
          </DescriptionText>
        </StepHeader>
      </DowntimeCard>
      <ShowDisclosureModal />
    </PageWrapper>
  );
};

export default DownTimePage;
